import { useEffect } from 'react';
import { useSession } from 'next-auth/react';
import { AMPLIFI_SESSION_USER_DATASET_KEY } from 'src/utils/amplifi/sessionUser';

export function PublishAmplifiSessionUser() {
  const { data: session, status } = useSession();

  useEffect(() => {
    const root = document.documentElement;
    if (status === 'loading') return;

    if (status !== 'authenticated' || !session?.user?.id) {
      delete root.dataset[AMPLIFI_SESSION_USER_DATASET_KEY];
      return;
    }

    root.dataset[AMPLIFI_SESSION_USER_DATASET_KEY] = session.user.id;
  }, [session?.user?.id, status]);

  return null;
}
